"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _lodash = _interopRequireDefault(require("lodash"));

var _AblyProvider = _interopRequireDefault(require("../providers/AblyProvider"));

var _xApiEventService = _interopRequireDefault(require("./xApiEventService"));

var _constants = require("../shared/constants");

var _interfaces = require("../shared/interfaces");

var _logger = _interopRequireDefault(require("../utils/logger"));

var _monitoringService = _interopRequireDefault(require("./monitoringService"));

/**
 * @fileoverview Realtime service providing generic methods for publishing realtime messages, subscribing to message
 * channels, and registering message event.
 * Must be initialized to use a provider of a specific pub/sub service (i.e. Ably).
 */
var RealtimeService = /*#__PURE__*/function () {
  function RealtimeService() {
    (0, _classCallCheck2.default)(this, RealtimeService);
    (0, _defineProperty2.default)(this, "eventListeners", []);
    (0, _defineProperty2.default)(this, "subscribedChannels", []);
    (0, _defineProperty2.default)(this, "provider", void 0);
    (0, _defineProperty2.default)(this, "cachedListenerObjs", []);
  }

  (0, _createClass2.default)(RealtimeService, [{
    key: "init",
    value: function init(ampConfig, userId, filterConfig, connectionChangeCallback) {
      var provider = _lodash.default.get(ampConfig, 'realtime.provider');

      var config = _lodash.default.get(ampConfig, "realtime.".concat(provider));

      if (!provider) {
        throw new Error('AmpRealtime cannot be initialized. Provider is not set.');
      }

      if (!config) {
        throw new Error("AmpRealtime cannot be initialized. Missing configuration for ".concat(provider, "."));
      }

      try {
        if (provider === _constants.PROVIDERS.ABLY) {
          this.provider = new _AblyProvider.default(config, userId, connectionChangeCallback);
          this.provider.init(this.onMessage.bind(this));
        } else {
          throw new Error('Unrecognized provider');
        }

        if (this.provider.setFilter && filterConfig) {
          var userRole = filterConfig.userRole;
          this.provider.setFilter(userRole);
        }
      } catch (err) {
        throw new Error("AmpRealtime cannot be initialized. Failed to initialize ".concat(provider, " provider - ").concat(err.message));
      }
    }
  }, {
    key: "publish",
    value: function publish(channelName, eventType, payload) {
      var recipient = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _constants.ROLES.ALL;

      if (this.provider) {
        return this.provider.publish(channelName, eventType, payload, recipient).then(function () {
          _xApiEventService.default.aggregateMessages(channelName, _interfaces.xAPIVerb.Sent, eventType);
        });
      } else {
        throw new Error('Cannot publish message. Provider was not properly initialized.');
      }
    }
    /**
     * Add a message listener for a given event type.
     *
     * `wrappedCallback` is an optional reference to the original callback from the client; we need to maintain this
     * reference so that clients are able to remove the listener by passing the original callback.
     */

  }, {
    key: "addEventListener",
    value: function addEventListener(eventType, callback, wrappedCallback, channelOrChannels) {
      var channelNames = Array.isArray(channelOrChannels) ? channelOrChannels : channelOrChannels ? [channelOrChannels] : undefined;

      this._addEventListener({
        eventType: eventType,
        callback: callback,
        wrappedCallback: wrappedCallback,
        channelNames: channelNames
      });
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(eventType, callback) {
      this._removeEventListener({
        eventType: eventType,
        callback: callback
      });
    }
  }, {
    key: "removeListenersForType",
    value: function removeListenersForType(eventType) {
      this.eventListeners = this.eventListeners.filter(function (listener) {
        return listener.eventType !== eventType;
      });
    }
  }, {
    key: "removeAllEventListeners",
    value: function removeAllEventListeners() {
      this.eventListeners = [];
    }
  }, {
    key: "addPresenceListener",
    value: function addPresenceListener(channelName, callback) {
      if (this.provider) {
        if (this.provider.presenceEventType) {
          var _eventType = this.provider.presenceEventType;
          var channelNames = [channelName];

          this._addEventListener({
            eventType: _eventType,
            callback: callback,
            channelNames: channelNames
          });
        } else {
          _logger.default.warn('Not adding presence listener. Provider has no presenceEventType.');
        }
      } else {
        throw new Error('Cannot add presence listener. Provider was not properly initialized.');
      }
    }
  }, {
    key: "removePresenceListener",
    value: function removePresenceListener(channelName, callback) {
      if (this.provider) {
        if (this.provider.presenceEventType) {
          var _eventType2 = this.provider.presenceEventType;
          var channelNames = channelName ? [channelName] : undefined;

          this._removeEventListener({
            eventType: _eventType2,
            callback: callback,
            channelNames: channelNames
          });
        } else {
          _logger.default.warn('Not removing presence listener. Provider has no presenceEventType.');
        }
      } else {
        throw new Error('Cannot remove presence listener. Provider was not properly initialized.');
      }
    }
  }, {
    key: "getCurrentSubscribers",
    value: function getCurrentSubscribers(channelName) {
      if (this.provider) {
        return this.provider.getCurrentSubscribers(channelName);
      } else {
        throw new Error('Cannot get subscribers. Provider was not properly initialized.');
      }
    }
    /**
     * Subscribe to channels.
     * If channel is already subscribed to, make sure the caller is added to the subscription owners and
     * that withPresence is set correctly for the channel subscription.
     */

  }, {
    key: "subscribeToChannels",
    value: function subscribeToChannels(channelNames, withPresence) {
      var _this = this;

      var caller = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.SUBSCRIPTION_OWNERS.CLIENT;

      if (this.provider) {
        var withPresenceArg = withPresence;
        channelNames = Array.isArray(channelNames) ? channelNames : [channelNames];
        withPresence = withPresence === true;
        var channelsToAdd = [],
            channelsToResubscribe = [];
        channelNames.forEach(function (channelName) {
          var subscribedChannel = _this.subscribedChannels.find(function (_ref) {
            var name = _ref.name;
            return name === channelName;
          });

          if (subscribedChannel) {
            // Make sure caller is added to the subscription owners, and
            // that withPresence is updated for this owner.
            var channelOwner = subscribedChannel.owners.find(function (_ref2) {
              var owner = _ref2.owner;
              return owner === caller;
            });

            if (!channelOwner) {
              subscribedChannel.owners.push({
                owner: caller,
                withPresence: withPresence
              });
            } else {
              channelOwner.withPresence = withPresence;
            }

            channelsToResubscribe.push(subscribedChannel);
          } else {
            channelsToAdd.push({
              name: channelName,
              withPresence: withPresence,
              owners: [{
                owner: caller,
                withPresence: withPresence
              }]
            });
          }
        });
        this.resubscribeChannels(channelsToResubscribe, withPresenceArg);

        if (channelsToAdd.length > 0) {
          this.subscribedChannels = this.subscribedChannels.concat(channelsToAdd);
          var channelNamesToAdd = channelsToAdd.map(function (channel) {
            return channel.name;
          });
          this.provider.subscribeToChannels(channelNamesToAdd, withPresence);

          _monitoringService.default.reportAction('Subscribed to channels', channelNamesToAdd, "Subscribed to ".concat(channelNamesToAdd.length, " channel(s)"));

          _xApiEventService.default.handleSubscriptionEvents(channelNamesToAdd, _interfaces.xAPIVerb.Subscribed, this.provider.presenceEventType);
        }
      } else {
        throw new Error('Cannot subscribe to channels. Provider was not properly initialized.');
      }
    }
    /**
     * Unsubscribe from channels.
     * If the caller is not the sole owner of a channel, remove them as a subscription owner but do not unsubscribe.
     * If forceUnsubscribe is true, unsubscribe regardless of subscription owners.
     */

  }, {
    key: "unsubscribeFromChannels",
    value: function unsubscribeFromChannels(channelNames) {
      var _this2 = this;

      var caller = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.SUBSCRIPTION_OWNERS.CLIENT;

      if (this.provider) {
        channelNames = Array.isArray(channelNames) ? channelNames : [channelNames];
        var channelsToRemove = [];
        channelNames.forEach(function (channelName) {
          var subscribedChannel = _this2.subscribedChannels.find(function (_ref3) {
            var name = _ref3.name;
            return name === channelName;
          });

          if (subscribedChannel) {
            // Remove caller from subscription owners.
            subscribedChannel.owners = subscribedChannel.owners.filter(function (_ref4) {
              var owner = _ref4.owner;
              return owner !== caller;
            }); // Determine subscriptions to remove. Include only channels that have no additional owners.

            if (_lodash.default.isEmpty(subscribedChannel.owners)) {
              channelsToRemove.push(channelName);
            } else {
              _logger.default.warn("Not unsubscribing from ".concat(channelName, ", since this channel is being used by ") + "".concat(subscribedChannel.owners.map(function (_ref5) {
                var owner = _ref5.owner;
                return owner;
              }), "."));
            }
          }
        });

        if (channelsToRemove.length > 0) {
          this.subscribedChannels = this.subscribedChannels.filter(function (_ref6) {
            var name = _ref6.name;
            return !channelsToRemove.includes(name);
          });
          this.provider.unsubscribeFromChannels(channelsToRemove);

          _monitoringService.default.reportAction('Unsubscribed from channels', channelsToRemove, "Unsubscribed from ".concat(channelsToRemove.length, " channel(s)"));

          _xApiEventService.default.handleSubscriptionEvents(channelsToRemove, _interfaces.xAPIVerb.Unsubscribed, this.provider.presenceEventType);
        }
      } else {
        throw new Error('Cannot unsubscribe from channels. Provider was not properly initialized.');
      }
    }
    /**
     * Unsubscribe all channels.
     */

  }, {
    key: "unsubscribeFromAll",
    value: function unsubscribeFromAll() {
      var caller = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.SUBSCRIPTION_OWNERS.CLIENT;
      var channelNames = Object.values(this.subscribedChannels).map(function (channel) {
        return channel.name;
      });
      this.unsubscribeFromChannels(channelNames, caller);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.provider) {
        this.provider.destroy();
      }
    }
    /**
     * Handle an incoming message of a specific type and channel.
     */

  }, {
    key: "onMessage",
    value: function onMessage(eventType, channelName, payload, publisherUuid) {
      var listeners = this.eventListeners.filter(function (listener) {
        return listener.eventType === eventType && (listener.channelNames === undefined || listener.channelNames.includes(channelName));
      });
      listeners.forEach(function (listener) {
        listener.callback(channelName, payload, publisherUuid);
      });

      if (!_lodash.default.isEmpty(eventType)) {
        _xApiEventService.default.aggregateMessages(channelName, _interfaces.xAPIVerb.Received, eventType);
      }
    }
    /**
     * Resubscribe to channels if we're reestablishing a server connection.
     */

  }, {
    key: "onReconnect",
    value: function onReconnect() {
      var channelsWithPresence = this.subscribedChannels.filter(function (channel) {
        return channel.withPresence;
      });
      var channelsWithoutPresence = this.subscribedChannels.filter(function (channel) {
        return !channel.withPresence;
      });

      if (channelsWithPresence.length > 0) {
        this.provider.subscribeToChannels(channelsWithPresence.map(function (channel) {
          return channel.name;
        }), true);
      }

      if (channelsWithoutPresence.length > 0) {
        this.provider.subscribeToChannels(channelsWithoutPresence.map(function (channel) {
          return channel.name;
        }), false);
      }

      _xApiEventService.default.handleSubscriptionEvents(this.subscribedChannels.map(function (channel) {
        return channel.name;
      }), _interfaces.xAPIVerb.Subscribed, this.provider.presenceEventType);
    }
  }, {
    key: "_addEventListener",
    value: function _addEventListener(_ref7) {
      var eventType = _ref7.eventType,
          callback = _ref7.callback,
          wrappedCallback = _ref7.wrappedCallback,
          channelNames = _ref7.channelNames;

      if (!this.eventListeners.find(function (listener) {
        var eventTypesMatch = listener.eventType === eventType;
        var callbacksMatch = listener.callback === callback;
        var wrappedCallbacksMatch = wrappedCallback !== undefined && listener.wrappedCallback === wrappedCallback;
        var anyCallbacksMatch = callbacksMatch || wrappedCallbacksMatch;

        var channelsMatch = _lodash.default.isEqual(listener.channelNames, channelNames);

        return eventTypesMatch && anyCallbacksMatch && channelsMatch;
      })) {
        this.eventListeners.push({
          eventType: eventType,
          callback: callback,
          wrappedCallback: wrappedCallback,
          channelNames: channelNames
        });
      }
    }
  }, {
    key: "_removeEventListener",
    value: function _removeEventListener(_ref8) {
      var eventType = _ref8.eventType,
          callback = _ref8.callback,
          channelNames = _ref8.channelNames;
      this.eventListeners = this.eventListeners.filter(function (listener) {
        return !(listener.eventType === eventType && (listener.wrappedCallback === callback || listener.callback === callback) && _lodash.default.isEqual(listener.channelNames, channelNames));
      });
    }
    /**
     * Resubscribe to channels in order to update their withPresence values. Do a re-subscribe if:
     *   - A channel's withPresence value is being changed
     *   - A channel's withPresence is being set to false and there is no subscription owner that still requires it to
     *     be true
     */

  }, {
    key: "resubscribeChannels",
    value: function resubscribeChannels(channels, withPresence) {
      var _this3 = this;

      if (_lodash.default.isNil(withPresence)) return;
      withPresence = withPresence === true;
      var channelsToResubscribe = channels.filter(function (channel) {
        if (channel.withPresence === withPresence) {
          return false;
        } // Do not let withPresence be set to false unless there is no owner subscribed with presence.


        if (!withPresence) {
          var ownersWithPresence = channel.owners.filter(function (_ref9) {
            var withPresence = _ref9.withPresence;
            return withPresence === true;
          });

          if (ownersWithPresence.length > 0) {
            _logger.default.warn("Not removing presence for ".concat(channel.name, ", since this channel is being used by ") + "".concat(ownersWithPresence.map(function (_ref10) {
              var owner = _ref10.owner;
              return owner;
            }), "."));

            return false;
          }
        }

        return true;
      });

      if (channelsToResubscribe.length > 0) {
        var channelNames = channelsToResubscribe.map(function (channel) {
          return channel.name;
        });
        channelNames.forEach(function (channelName) {
          var subscribedChannel = _this3.subscribedChannels.find(function (_ref11) {
            var name = _ref11.name;
            return name === channelName;
          });

          subscribedChannel.withPresence = withPresence;
        });
        this.provider.unsubscribeFromChannels(channelNames);

        _xApiEventService.default.handleSubscriptionEvents(channelNames, _interfaces.xAPIVerb.Unsubscribed, this.provider.presenceEventType);

        this.provider.subscribeToChannels(channelNames, withPresence);

        _xApiEventService.default.handleSubscriptionEvents(channelNames, _interfaces.xAPIVerb.Subscribed, this.provider.presenceEventType);
      }
    }
    /**
     * Wrap messages callback in a listener object to add event tracking.
     */

    /* eslint-disable @typescript-eslint/no-explicit-any */

  }, {
    key: "wrapListenerCallbacks",
    value: function wrapListenerCallbacks(listenerObj) {
      if (listenerObj && listenerObj.message instanceof Function) {
        var wrappedObj = _lodash.default.cloneDeep(listenerObj);

        var originalCallback = listenerObj.message; // only wrap message handler

        wrappedObj.message = function (message) {
          var knownTypes = ['message.map.messageType', 'message.type'];
          var messageType = knownTypes.reduce(function (messageType, path) {
            if (messageType === null) {
              return _lodash.default.get(message, path, null);
            }

            return messageType;
          }, null);

          if (messageType !== null) {
            _xApiEventService.default.aggregateMessages(message.channel, _interfaces.xAPIVerb.Received, messageType);
          }

          originalCallback(message);
        };

        this.cachedListenerObjs.push({
          listenerObj: listenerObj,
          wrappedObj: wrappedObj
        });
        return wrappedObj;
      }

      return listenerObj;
    }
    /**
     * Subscribe to channels with listener callbacks
     * Not intended for future use.
     *
     * @deprecated included only to support gradual apps migration.
     */

    /* eslint-disable @typescript-eslint/no-explicit-any */

  }, {
    key: "subscribeAndListen",
    value: function subscribeAndListen(channelNames, listenerObj, withPresence) {
      if (this.provider) {
        var wrappedListenerObj = this.wrapListenerCallbacks(listenerObj);
        this.provider.subscribeAndListen(channelNames, wrappedListenerObj, withPresence);
      }
    }
    /**
     * Remove listener and unsubscribe.
     * Not intended for future use.
     *
     * @deprecated included only to support gradual apps migration.
     */

    /* eslint-disable @typescript-eslint/no-explicit-any */

  }, {
    key: "stopListeningAndUnsubscribe",
    value: function stopListeningAndUnsubscribe(channelsNames, listenerObj) {
      if (this.provider) {
        var cachedListener = this.cachedListenerObjs.find(function (listener) {
          return listener.listenerObj === listenerObj;
        });
        var listenerForUnsubscribe = cachedListener ? cachedListener.wrappedObj : listenerObj;
        this.provider.stopListeningAndUnsubscribe(channelsNames, listenerForUnsubscribe);

        if (cachedListener) {
          this.cachedListenerObjs = this.cachedListenerObjs.filter(function (listener) {
            return listener.listenerObj !== listenerObj;
          });
        }
      }
    }
    /**
     * Get timestamp as ms since epoch as synced with realtime source
     */

  }, {
    key: "getTimeMs",
    value: function () {
      var _getTimeMs = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.provider.getTimeMs());

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getTimeMs() {
        return _getTimeMs.apply(this, arguments);
      }

      return getTimeMs;
    }()
  }]);
  return RealtimeService;
}();

var _default = new RealtimeService();

exports.default = _default;
//# sourceMappingURL=realtimeService.js.map